
import ImageEditor from './components/AssemblyPoint';
import { TABS_IDS, TOOLS_IDS } from './utils/constants';

export { TABS_IDS as TABS, TOOLS_IDS as TOOLS };

export default ImageEditor;
